import {useClient, useDictionary} from '@adamlip/okeoke.client';
import {Chip, Image, Modal, ModalBody, ModalContent, ModalHeader} from '@heroui/react';
import BarSoftButton from 'components/_NewComponents/BarSoftButton';
import {UserContext} from 'contexts/UserContext';
import {CalendarDays, Store} from 'lucide-react';
import moment from 'moment';
import {useContext, useEffect} from 'react';

export default function CouponModalV2({isOpen, setIsOpen, coupon, handleActivateCoupon, handleDeActivateCoupon, currentCoupon, activateInProgress, setCurrentCoupon}) {
	const {getValue} = useDictionary();
	const {stores, selectedStore} = useContext(UserContext);
	const {getName} = useClient();

	useEffect(() => {
		if (coupon) {
			setCurrentCoupon(coupon);
		}
		//eslint-disable-next-line
	}, [coupon]);

	return (
		<Modal isOpen={isOpen} onOpenChange={() => setIsOpen(!isOpen)}>
			<ModalContent>
				{(onClose) => (
					<>
						<ModalHeader className='flex flex-col gap-1'>{currentCoupon?.name}</ModalHeader>
						<ModalBody>
							<div className='select-none grow flex flex-col gap-2 overflow-y-scroll'>
								{currentCoupon?.attributes?.imageUrl != null && (
									<Image
										src={coupon?.attributes?.imageUrl}
										classNames={{
											img: 'object-cover w-full h-full rounded-none z-auto',
											wrapper: ' overflow-hidden w-full z-auto rounded-none !max-w-full h-[200px]',
										}}
									/>
								)}
								<div className={`flex flex-col gap-2 px-2`}>
									{currentCoupon && (
										<>
											<div className='flex flex-col items-start gap-1 justify-start'>
												<p className='text-medium  opacity-50'>{getValue('app_v2_coupons_coupon_details')}</p>
												{Object.values(stores || {}).filter((store) => (currentCoupon?.stores || []).includes(store.id)).length > 0 && <div className='text-sm font-medium'>{getValue('app_v2_coupons_availableStores')}</div>}
												{Object.values(stores || {})
													.filter((store) => (currentCoupon?.stores || []).includes(store.id))
													.map((store) => (
														<Chip startContent={<Store className='stroke-current h-4 w-4' />} key={store.id} color={store?.id === selectedStore?.id ? 'primary' : 'default'}>
															<p>{store.name}</p>
														</Chip>
													))}
											</div>
											<div className='flex flex-col gap-2'>
												<div className='text-sm opacity-70'>{getName(currentCoupon?.description)}</div>
												<div className='gap-1 flex flex-row items-center text-sm opacity-70 pt-1'>
													<CalendarDays className='w-4 h-4' />
													{getValue('app_v2_coupons_couponAvailable')}: {moment(currentCoupon?.endDate).format('YYYY.MM.DD')}
												</div>
											</div>
										</>
									)}
								</div>
							</div>
							<div className='w-full flex flex-row px-2 gap-2'>
								{currentCoupon?.active !== true && (
									<BarSoftButton isLoading={activateInProgress} fullWidth={true} color='primary' className='' onPress={() => handleActivateCoupon(currentCoupon)} isDisabled={activateInProgress}>
										{getValue('app_v2_coupons_activeCoupon')}
									</BarSoftButton>
								)}
								{currentCoupon?.active === true && (
									<BarSoftButton isLoading={activateInProgress} fullWidth={true} color='primary' className='' onPress={() => handleDeActivateCoupon(currentCoupon)} isDisabled={activateInProgress}>
										{getValue('app_v2_coupons_alreadyActivated')}
									</BarSoftButton>
								)}
							</div>
						</ModalBody>
					</>
				)}
			</ModalContent>
		</Modal>
	);
}
